import PropTypes from "prop-types";
import { Row, Select, Spin } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import API from "../services/api-request";

const mergeUniqueById = (prevData, newData) => {
  const existingIds = new Set(prevData.map((item) => item.id));
  return [
    ...prevData,
    ...newData.filter((item) => !existingIds.has(item.id)),
  ];
};

const SelectOperator = ({ value, onChange }) => {
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUser = useCallback(async () => {
    setLoading(true);
    API.Get(`user?id_privilege=6`)
      .then((res) => {
        const newData = res?.data;
        setListData((prevData) => mergeUniqueById(prevData, newData));
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    getUser();
  }, [getUser]);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Pilih Operator"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.name,
        value: e.id,
      }))}
    />
  );
};


SelectOperator.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default SelectOperator;
